import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=507529d9&scoped=true&"
import script from "./SecondStep.vue?vue&type=script&lang=ts&"
export * from "./SecondStep.vue?vue&type=script&lang=ts&"
import style0 from "./SecondStep.vue?vue&type=style&index=0&id=507529d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507529d9",
  null
  
)

export default component.exports